/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import {
  Box, Collapse, List, ListItemText,
} from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({
  data = [], nest = [], openNav, ...other
}) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ ml: nest.length ? 1 : 0, mr: nest.length ? 1 : 0 }}>
        {(data.length ? data : nest).map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const {
    title, path, icon, info, end, nest, onClick, disabled, openNav,
  } = item;
  const theme = useTheme();

  let expand; let setExpand;
  if (nest) {
    const state = useState(false);
    [expand, setExpand] = state;
  }

  return (
    <div
      onMouseLeave={() => { if (nest) setExpand(false); }}
      onMouseEnter={() => { if (!disabled && nest) setExpand(true); }}
    >
      <StyledNavItem
        disabled={disabled}
        component={path ? RouterLink : 'div'}
        to={path}
        end={end}
        onClick={(event) => {
          if (nest) { setExpand(!expand); event.preventDefault(); }
          onClick?.();
        }}
        sx={{
          // '-webkit-box-shadow': `inset 0px 0px 0px 2px ${theme.palette.primary.lighter}`,
          // '-moz-box-shadow': `inset 0px 0px 0px 2px ${theme.palette.primary.lighter}`,
          // 'box-shadow': `inset 0px 0px 0px 2px ${theme.palette.primary.lighter}`,
          margin: '0.5px 0px',
          '&.active': {
            color: 'text.primary',
            bgcolor: 'action.selected',
            fontWeight: 'fontWeightBold',
          },
        }}
      >
        <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

        <ListItemText disableTypography primary={title} />

        {info && info}

        {nest && (expand ? <ExpandLess sx={{ mr: 1 }} /> : <ExpandMore sx={{ mr: 1 }} />)}
      </StyledNavItem>
      {nest && (
        <Collapse in={expand} timeout="auto" unmountOnExit>
          <NavSection nest={nest} />
        </Collapse>
      )}
    </div>
  );
}
